module.exports = __webpack_public_path__ + "static/hugh_fadal3-a7354323c32f389f1ab415f399fa853e.jpg";